import { generateHTML, generateJSON } from '@tiptap/core'

import { createRichTextExtensions } from './extensions'

const EMPTY_PARAGRAPH = '<p></p>'

/**
 * A rich text value counts as filled when it has at least one non-whitespace
 * character, an image or a table (an empty editor serializes to `<p></p>`).
 */
export const isRichTextEmpty = (html?: string | null): boolean => {
  if (!html) return true
  const doc = new DOMParser().parseFromString(html, 'text/html')
  if (doc.body.querySelector('img, table')) return false
  return !doc.body.textContent?.trim()
}

/**
 * Drop leading/trailing empty paragraphs (e.g. the one the editor appends after
 * a trailing table or image), the rich text equivalent of trimming a string.
 */
export const trimRichTextHtml = (html: string): string => {
  let result = html
  while (result.startsWith(EMPTY_PARAGRAPH)) result = result.slice(EMPTY_PARAGRAPH.length)
  while (result.endsWith(EMPTY_PARAGRAPH)) result = result.slice(0, -EMPTY_PARAGRAPH.length)
  return result
}

/** Re-serialize stored HTML the way the editor would, so it can be compared with editor output */
export const normalizeRichTextHtml = (html?: string | null): string => {
  if (!html) return ''
  const extensions = createRichTextExtensions()
  return trimRichTextHtml(generateHTML(generateJSON(html, extensions), extensions))
}
